import React, { useState, useEffect } from 'react';
import { Switch, Route, withRouter, RouteComponentProps, Redirect } from 'react-router';
import { bindActionCreators } from 'redux';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../styles/main.scss';
import { connect } from 'react-redux';
import { SITE_URLS } from '@constants/routes';
import { ERROR_CODE, USER_VALID_STATUS } from '@constants/common';
import { ErrorPage } from '@react/pages';
import { SITE } from '@localisation/components';
import { initAccountInfo } from '@redux/actions/account.actions';
import { initSectors } from '@redux/actions/sector.actions';
import { ERROR_MESSAGE } from '@localisation/message';
import CallbackRoute from '@react/components/route/callbackRoute.component';
import { hasOrgAccess, isValidUser } from './utils/auth.util';
import { commonRoutes, publicRoutes, internalRoutes, callbackRoute } from './routes';
import { StandardLayout } from './layout/layout.loadable';

interface IAppStateProps {
  user,
  account
}
interface IAppDispatchProps {
  initAccountInfo,
  initSectors,
}
type IAppProps = RouteComponentProps & IAppStateProps & IAppDispatchProps;
// add check to show public or internal route based on props;
class App extends React.Component<IAppProps>{
  componentDidMount() {
    this.props.initAccountInfo();
    this.props.initSectors();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.user && this.props.user) {
      this.props.initAccountInfo();
    }
  }

  render() {
    const { user, account } = this.props;

    const routes = [...commonRoutes, ...account.get('isPublicUser') ? publicRoutes : internalRoutes];
    const userGuid = account.get('userGuid');
    return (
      <React.Fragment>
        <Switch>
          <CallbackRoute
            path={callbackRoute.path}
            exact={!!callbackRoute.exact}
            component={callbackRoute.component}
          />
          <Route
            path={routes.map(route => route.path)}
            exact={true}
            render={() => <StandardLayout routes={routes} />}
          />
          <Route path="*">
            <ErrorPage {...({ ...this.props, code: ERROR_CODE.NOT_FOUND })} />
          </Route>
        </Switch>
      </React.Fragment>
    );
  }
}

interface IRouteProps {
  match?;
}




const mapStateToProps = (state) => ({
  user: state.getIn(['Oidc', 'user']),
  account: state.getIn(['Account', 'accountInfo'])
});
const mapDispatchToProps = (dispatch: any) => ({
  ...bindActionCreators(
    {
      initAccountInfo,
      initSectors,
    },
    dispatch
  )
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));